import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { FaFileDownload } from 'react-icons/fa';
import PbUmkuService from '../../../services/pbumku/PbumkuService';
import Card from '../../../components/Card';
import DataTable from 'react-data-table-component';

const DokChecklist = () => {
    const columns = [
        {
            name: 'No',
            cell: row => row['id'],
            grow: 0
        },
        {
            name: 'Jenis Checklist',
            cell: row => row['jnsChecklist'],
            grow: 1
        },
        {
            name: 'Nama Checklist',
            cell: row => row['nmChecklist'],
            grow: 1
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-md-12'>
                            <OverlayTrigger placement='bottom' overlay={
                                <Tooltip>Download Template</Tooltip>
                            }>
                                <Button size='sm' variant='info' onClick={() => handleClickDownload(row)}>
                                    <FaFileDownload />{' '}Download Template
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </>
            )
        }
    ]

    let pbUmkuService = useMemo(() => new PbUmkuService(), [])

    const [listChecklistDok, setListChecklistDok] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListChecklistDok = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await pbUmkuService.listChecklistDokumen(page, size)
            setListChecklistDok(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setListChecklistDok([])
        }
        setLoading(false)
    }, [pbUmkuService])

    useEffect(() => {
        getListChecklistDok(0, 10)
    }, [getListChecklistDok])

    const handleChangePage = (page) => {
        getListChecklistDok(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const response = await pbUmkuService.listChecklistDokumen(page - 1, size)
        setListChecklistDok(response.data.data)
        setSize(size)
    }

    const handleClickDownload = (row) => {
        downloadExcelFromBase64(row.fileContent, 'Template-' + row.nmChecklist + '.xlsx')
    }


    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Template Dokumen Checklist</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listChecklistDok}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

function downloadExcelFromBase64(base64Data, fileName = 'file.xlsx') {
    // Decode the Base64 string
    const binaryData = atob(base64Data);

    // Convert binary string to ArrayBuffer
    const len = binaryData.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob with the appropriate MIME type for Excel
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Programmatically click the link to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up the link element
    document.body.removeChild(link);
}

export default DokChecklist